import { Box, Paper } from '@mui/material';

import { type PropertyMapMode } from '@modules/_shared/components/property-map/property-map-types';
import { PropertyMapViewer } from '@modules/_shared/components/property-map/PropertyMapViewer';
import { useAppData } from '@modules/_shared/providers/AppDataProvider';

type PropertyForMap = {
  id: string;
  lat?: number | null;
  lng?: number | null;
  google_address?: { lat?: number | null; lng?: number | null } | null;
  country_code?: string | null;
};

type LeadDetailsMapProps = {
  property: PropertyForMap;
  initialTab?: PropertyMapMode;
  previewMode?: boolean;
  actionsEnabled?: boolean;
};

export const LeadDetailsMap = ({
  property,
  initialTab = 'map',
  previewMode = false,
  actionsEnabled = true,
}: LeadDetailsMapProps) => {
  const { me } = useAppData();

  const isSwitzerland = property.country_code?.toUpperCase() === 'CH';
  const isReadOnly = previewMode || !actionsEnabled;
  const showControls = (me?.is_admin ?? false) || actionsEnabled;

  const lat = property.lat ?? property.google_address?.lat;
  const lng = property.lng ?? property.google_address?.lng;
  const hasCoordinates = lat != null && lng != null;

  if (!hasCoordinates) {
    return null;
  }

  const modeOrder: PropertyMapMode[] = ['satellite', '3d', 'map', 'streetView'];

  if (isSwitzerland && !isReadOnly) {
    modeOrder.push('zoning');
  }

  return (
    <Paper
      sx={{
        height: '25vh',
        minHeight: 300,
        position: 'relative',
        overflow: 'hidden',
        borderRadius: { xs: 0, md: 3 },
      }}
    >
      <Box sx={{ position: 'absolute', inset: 0 }}>
        <PropertyMapViewer
          lat={lat}
          lng={lng}
          initialMode={initialTab}
          modeOrder={modeOrder}
          readOnly={isReadOnly}
          showControls={showControls}
          showInset
          showCameraControl={false}
        />
      </Box>
    </Paper>
  );
};
